import React, {Component} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import api from '../../services/api';
import Image from 'react-bootstrap/esm/Image';

export default class Listaparceiros extends Component{
   // executa após o componente ser ativado
   componentDidMount (){
      this.loadDados();
   }

   // carrega os dados da api... promisse
   loadDados = async () =>{
      const {data} = await api.get('/parceiro');
      this.setState({ dados: data });
   }

     // armazena os dados no estado
     state = {
      dados: [],
   }
   // renderiza o componente 
   render(){
      return ( 
         <div>
            <Row className="mt-4">
               { this.state.dados.map ( dado => (
                  <Col sm={2} className="mb-4" key = {dado.id}>
                     <Image src={dado.imagem_destacada.guid} className="img-fluid rounded" />
                  </Col>
               )) }
            </Row>
         </div>
      )
   }
}